module.exports = __webpack_public_path__ + "img/DSC_0054.67ee8aa2.jpg";